import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IButtonElement) {
    (function(ButtonVariant) {
        ButtonVariant["BUTTON_VARIANT_UNKNOWN"] = "BUTTON_VARIANT_UNKNOWN";
        ButtonVariant["PRIMARY"] = "PRIMARY";
        ButtonVariant["SECONDARY"] = "SECONDARY";
        ButtonVariant["TERTIARY"] = "TERTIARY";
    })(IButtonElement.ButtonVariant || (IButtonElement.ButtonVariant = {}));
    (function(IButtonStyle) {
        IButtonStyle.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IButtonElement.IButtonStyle || (IButtonElement.IButtonStyle = {}));
    (function(IFaireIconText) {
        (function(FaireIconPosition) {
            FaireIconPosition["FAIRE_ICON_POSITION_UNKNOWN"] = "FAIRE_ICON_POSITION_UNKNOWN";
            FaireIconPosition["START"] = "START";
            FaireIconPosition["END"] = "END";
        })(IFaireIconText.FaireIconPosition || (IFaireIconText.FaireIconPosition = {}));
        IFaireIconText.build = function(partial) {
            return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IButtonElement.IFaireIconText || (IButtonElement.IFaireIconText = {}));
    IButtonElement.build = function(partial) {
        return _object_spread({
            on_click: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IButtonElement || (IButtonElement = {}));
export var IButtonElement;
